module.exports = __webpack_public_path__ + "media/images/emblems/Weisslingen-blazon-2ebf4064922fcab21751f665e0bb72b5.svg";